import { Skeleton } from "@coval/ui"

/**
 * Skeleton that mimics the shape of a loaded chart widget:
 * Y-axis labels, horizontal grid lines, X-axis date labels, and a legend row.
 * It stands in for a widget's body only — the card around it carries the title,
 * so a title here would be a second one that disappears when the data lands.
 */
export function ChartWidgetSkeleton() {
  return (
    <div className="flex flex-col h-full p-3 gap-2">
      {/* Chart area */}
      <div className="flex flex-1 min-h-0 gap-2">
        {/* Y-axis labels */}
        <div className="flex flex-col justify-between py-2 shrink-0">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="h-3 w-6 rounded" />
          ))}
        </div>

        {/* Grid lines area */}
        <div className="flex-1 flex flex-col justify-between py-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="h-px w-full rounded-none" />
          ))}
        </div>
      </div>

      {/* X-axis date labels */}
      <div className="flex justify-between pl-8">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-3 w-10 rounded" />
        ))}
      </div>

      {/* Legend row */}
      <div className="flex gap-4 pl-8 pt-1">
        <div className="flex items-center gap-1.5">
          <Skeleton className="h-2.5 w-2.5 rounded-full" />
          <Skeleton className="h-3 w-24 rounded" />
        </div>
        <div className="flex items-center gap-1.5">
          <Skeleton className="h-2.5 w-2.5 rounded-full" />
          <Skeleton className="h-3 w-20 rounded" />
        </div>
      </div>
    </div>
  )
}
